import { Link } from 'react-router-dom';
import bg from '../../../../assets/images/home/speakup-game/game-bg.svg';
import teamWIthFlag from '../../../../assets/images/home/team-statistics/image with flage.svg';
import { BsArrowRight } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { TeamStatisticsContainer } from './TeamStatistics.style';

const TeamStatistics = () => {
	const { t } = useTranslation();
	return (
		<TeamStatisticsContainer className="relative w-full bg-cover bg-right" style={{ backgroundImage: `url(${bg})` }}>
			<div className="absolute bottom-0 flex items-center px-4">
				<img src={teamWIthFlag} className="team__stats__img h-auto w-[40%] pb-1" alt="team-with-flags" />
				<div className="team__stats__content flex h-full w-[60%] flex-col justify-center">
					<h3 className="team__stats__header mb-0 font-manropeBold text-2xl text-white">{t('teamStatistics')}</h3>
					<p className="team__stats__text font-monospace text-xs text-[#FFFFFFCC]">
						Lorem ipsum, dolor sit amet consectetur adipisicing elit. Saepe beatae et iusto ab voluptatem eius
					</p>
					<Link to="/teams" className=" text-decoration-none">
						<button className="mb-3 flex flex-row items-center gap-2 rounded-lg bg-white px-6 py-2.5 text-[#01ABC1]">
							<span className="text__default font-manropeBold text-sm">Team Statistics</span>
							<BsArrowRight />
						</button>
					</Link>
				</div>
			</div>
		</TeamStatisticsContainer>
	);
};

export default TeamStatistics;
